import React from 'react'
import { Item } from '../../../../common/snippets'
import { Box, Button } from '@mui/material'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import DropDownOA from '../../../../common/dropDownOA'
import DemurrageChrgTable from './DemurrageChrgTable'
import { connect } from 'react-redux'
import { updateAlertError, updateModal } from '../../../../../store/common/common_action'
import * as mdt from '../../../../common/modaltypes'
import DemurrageChrgModal from './DemurrageChrgModal'
import { useState } from 'react'
import { useEffect } from 'react'
import { focusElemnt, isEmpty, navigation3 } from '../../../../common/helper'
import { bookingType, chargeType } from '../../GSConstants'
import { PaymentTypesOptions } from '../../../../common/constants'
import { getDemurrageChrg, updateDemurrageChrg } from '../../../../../store/generalSetting/GSAction'
import ConfirmModal from './ConfirmModal'

const DeliveryCharges = (props) => {
  const {
    data: { common },
    updateModal,
    updateAlertError,
    getDemurrageChrg,
    updateDemurrageChrg,
  } = props
  const { loginData, showModal, modalType, cnsgnmntTypes,companySettings } = common
  const UseToPayAsCOD=companySettings[0]?.UseToPayAsCOD
  const [selConsignmentType, setSelConsignmentType] = useState({ ConsignmentSubTypeID: 0, SubType: 'All' })
  const [selBookingType, setSelBookingType] = useState({ id: 0, name: 'All' })
  const [selChargeType, setSelChargeType] = useState({ id: 0, name: 'All' })
  const [selPaymentType, setSelPaymentType] = useState({ id: 0, Name: 'All' })
  const [reportData, setReportData] = useState([])
  useEffect(() => {
    focusElemnt('Booking_Type')
  }, [])
  useEffect(() => {
    if (!isEmpty(loginData)) {
      getDemurrageChrgList()
    }
  }, [loginData])
  const addDemurrageChrgModal = () => {
    const propsData = {
      isUpdate: false,
      headText: 'Add Demurrage Charge',
    }
    return <DemurrageChrgModal UseToPayAsCOD={UseToPayAsCOD} propsData={propsData} getDemurrageChrgList={getDemurrageChrgList} />
  }
  const getDemurrageChrgList = () => {
    setReportData([])
    if (selConsignmentType === '' || selConsignmentType === ' ') {
      updateAlertError({ show: true, msg: 'Please Select Consignment Type', nextId: 'Select_Consignment_Type' })
    } else {
      const body = {
        CompanyID: loginData?.intCompanyID,
        BookingType: selBookingType?.id,
        ChargeType: selChargeType?.id,
        ConsignmentType: selConsignmentType?.ConsignmentSubTypeID,
        PaymentType: selPaymentType?.id,
      }
      getDemurrageChrg(body)
        .then((res) => {
          if (res.status === 'Success') {
            const updatedData = res.Data.Table?.map((val) => ({
              ...val,
              PaymentType:
                UseToPayAsCOD === 1 && val.PayTypeID === 2
                  ? 'COD'
                  : val.PayTypeID === 7
                    ? 'COD Manual'
                    : val.PayTypeID === 9
                      ? 'COD DDDV'
                      : val.PaymentType,
            }))
            setReportData(updatedData)
          } else {
            updateAlertError({ show: true, msg: res?.ErrMessage, nextId: 'Select_Consignment_Type' })
          }
        })
        .catch((err) => {
          console.log('Error:', err)
        })
    }
  }
  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'start', alignItems: 'center', marginTop: '10px' }}>
        <Box sx={{ display: 'flex' }} className="itemButtons">
          <Item sx={sx.itemsx}>
            <DropDownOA
              id={'Booking_Type'}
              label={'Booking Type'}
              data={bookingType}
              defaultvalue={selBookingType?.name}
              idKey={`id`}
              dataKey={`name`}
              minWidth="250px"
              nextId={'Charge_Type'}
              onSelect={(val) => {
                setSelBookingType(val)
              }}
            />
          </Item>
          <Item sx={{ ...sx.itemsx, paddingX: '12px' }}>
            <DropDownOA
              id={'Charge_Type'}
              label={'Charge Type'}
              data={chargeType}
              idKey={`id`}
              dataKey={`name`}
              defaultvalue={selChargeType?.name}
              minWidth="250px"
              nextId={'Select_Consignment_Type'}
              prevId={`Booking_Type`}
              onSelect={(val) => {
                setSelChargeType(val)
              }}
            />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id={'Select_Consignment_Type'}
              label={'Select Consignment Type'}
              data={cnsgnmntTypes.length > 0 ? [{ ConsignmentSubTypeID: 0, SubType: 'All' }, ...cnsgnmntTypes] : []}
              defaultvalue={selConsignmentType?.SubType || selConsignmentType}
              onSelect={(val) => {
                setSelConsignmentType(val)
              }}
              idKey={`ConsignmentSubTypeID`}
              dataKey={`SubType`}
              minWidth="250px"
              prevId={`Charge_Type`}
              nextId={'Payment_Type'}
            />
          </Item>
          <Item sx={{ ...sx.itemsx, paddingLeft: '12px' }}>
            <DropDownOA
              id={'Payment_Type'}
              label={'Payment Type'}
              // data={PaymentTypesOptions}
              data={(PaymentTypesOptions || []).map((item) => {
                if (UseToPayAsCOD === 1) {
                  if (item.id === 2) {
                    return { ...item, Name: 'COD' };
                  }
                  if (item.id === 7) {
                    return { ...item, Name: 'COD Manual' };
                  }
                  if (item.id === 9) {
                    return { ...item, Name: 'COD DDDV' };
                  }
                  if (item.id === 4) {
                    return null;
                  }
                }
                return item;
              }).filter(Boolean)
              }
              defaultvalue={selPaymentType?.Name}
              dataKey={`Name`}
              idKey={`id`}
              minWidth="250px"
              nextId={'load_btn'}
              prevId={`Select_Consignment_Type`}
              onSelect={(val) => {
                setSelPaymentType(val)
              }}
            />
          </Item>
          <Item sx={{ ...sx.itemsx, paddingX: '12px' }} className="disabled-wrapper">
            <Button
              variant="contained"
              id={'load_btn'}
              sx={{ paddingY: '7px !important', height: '37px' }}
              className="btn btn-primary"
              onClick={getDemurrageChrgList}
              onKeyDown={(e) => navigation3(e, 'new_add_btn', 'Payment_Type', () => {})}
            >
              Load
            </Button>
          </Item>
          <Item sx={{ ...sx.itemsx }} className="disabled-wrapper">
            <Button
              variant="outlined"
              id={'new_add_btn'}
              sx={{ width: '100%' }}
              className="receiveitembtn"
              onClick={() => {
                updateModal(true, mdt.deliveryChrgModal)
              }}
              onKeyDown={(e) => navigation3(e, 'Booking_Type', 'load_btn', () => {})}
            >
              + ADD NEW DEMURRAGE CHARGES
            </Button>
          </Item>
        </Box>
      </Box>
      <Box sx={{ marginTop: '15px' }}>
        <DemurrageChrgTable
          UseToPayAsCOD={UseToPayAsCOD}
          updateModal={updateModal}
          reportData={reportData}
          showModal={showModal}
          modalType={modalType}
          cnsgnmntTypes={cnsgnmntTypes}
          loginData={loginData}
          updateAlertError={updateAlertError}
          getDemurrageChrgList={getDemurrageChrgList}
        />
      </Box>
      {showModal && mdt.deliveryChrgModal === modalType ? addDemurrageChrgModal() : null}
      {showModal && mdt.demurrageChrgConfModal === modalType ? <ConfirmModal updateModal={updateModal} /> : null}
    </>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { updateModal, updateAlertError, getDemurrageChrg, updateDemurrageChrg }
export default connect(mapStateToProps, mapDispatchToProps)(DeliveryCharges)
